import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  message: '',
  severity: 'info',
  variant: null,
};

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    showSnackbar: (state, action) => {
      state.open = true;
      state.message = action.payload.message;
      state.variant = action.payload.variant ?? null;
      state.severity = action.payload.severity;
      state.variant = action.payload.variant ?? null;
    },
    hideSnackbar: (state) => {
      state.open = false;
      state.message = '';
      state.severity = 'info';
      state.variant = null;
    },
  },
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
